import React from 'react';
export const RichTextEditorContext = React.createContext({});
export function useRichTextEditor() {
    return React.useContext(RichTextEditorContext);
}
